import classnames from 'classnames';
import { useContext } from 'react';
import { Link } from 'react-router-dom';

import { CompanyFragment } from '@willow/graphql-iso/src/portal';
import { Dropdown } from '@willow/shared-web/bootstrap';
import { LosId } from '@willow/types-iso';

import { usePortalAuth } from '../../../auth/portalAuthContext';
import { CompanyLogo } from '../../company-logo/CompanyLogo';
import { UserContext } from '../../context/UserContext';
import { MobileMenu } from '../mobile-menu/MobileMenu';

import './Banner.scss';

interface Props {
  selectedLoanId?: LosId;
  hasActiveLoan: boolean;
  company?: CompanyFragment;
}

export const Banner = ({ selectedLoanId, company, hasActiveLoan }: Props) => {
  const { logout } = usePortalAuth();

  // Form username (first name + first letter of last name)
  let userName;
  const { firstName, lastName } = useContext(UserContext);
  userName = firstName || null;
  if (lastName?.length) {
    userName += ` ${lastName[0]}.`;
  }

  // Base the page slug off of the selected loan id: /:loanId/whatever-page
  const baseSlug = selectedLoanId ? `/${selectedLoanId}/` : '/';

  return (
    <div role="banner" className={classnames(['banner'], { 'banner--no-company': !company })}>
      <div className="wrapper">
        {company && (
          <Link to={`${baseSlug}`} className="logo" aria-label={`${company.name}. Click to return to the home page.`}>
            <CompanyLogo company={company} />
          </Link>
        )}

        {userName && (
          <Dropdown>
            <Dropdown.Toggle aria-label={`${userName}. Click to see additional menu options.`}>
              {userName}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item as={Link} to="/" onClick={logout}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
        {!userName && (
          <a href="/" onClick={logout}>
            Logout
          </a>
        )}

        <MobileMenu
          selectedLoanId={selectedLoanId}
          hasActiveLoan={hasActiveLoan}
          company={company}
          baseSlug={baseSlug}
        />
      </div>
    </div>
  );
};
